import React, { useState } from 'react'
import axios from "axios";

// import Files
import * as Config from "../Utils/Config";
import { header } from "../Utils/ApiHeader";



// Admin Dashboard
export async function GETALL_SUB_ADMINS(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getall/subadmin`, data, {
            // headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {

    }

}
// Admin Dashboard
export async function GETALL_SUB_ADMINS_CLIENTS(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getall/subadmin/clients`, data, {
            // headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {

    }

}

// GET SUBADMINS PERMISSIONS
export async function GET_SUB_ADMINS_PERMISSIONS(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}sub/get/permissions`, data, {
            // headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {

    }

}





//  ------------------------


// ADD USER
export async function ADD_CLIENT(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}sub/add/employee`, data, {
            headers: header(token),
            data: { data },
        })
        return await res?.data;
    }
    catch (err) {

        return err

    }

}



// DELTE USER
export async function DELETE_USERAND_ALLSERVICES(data, token) {

    try {
        const res = await axios.post(`${Config.base_url}delete/user`, data, {
            //  headers: header(token),
            data: { data },
        })
        return await res?.data;

    }
    catch (err) {

        return err
        // custom error
    }

}



// ALL CLIENTS
export async function ALL_CLIENTS(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getall/clients`, data, {
            headers: header(token),
            data: {

                "page": "5",
                "limit": "1"

            },
        })
        return await res?.data;
    }
    catch (err) {

    }

}


// FIND ONE CLIENT BY ID
export async function FIND_ONE_USER(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getall/userinfo`, data, {
            headers: header(token),

        })
        return await res?.data;
    }
    catch (err) {

    }

}


// UPDATE CLIENT BY ID
export async function UPDATE_USER(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}sub/update/employee`, data, {
            headers: header(token),

        })
        return await res?.data;
    }
    catch (err) {

    }

}


// export async function GET_SUBADMIN_DASHBOARD_COUNT(token, subadmin_id) {
//     try {
//         const res = await axios.post(
//             `${Config.base_url}subadmin/get/dashboard/count`,
//             { subadmin_id }, // send in body
//             { headers: header(token) }
//         );
//         return res.data;
//     } catch (err) {
//         console.error("Error fetching Subadmin dashboard:", err);
//         return { status: false, msg: "Server error", data: [] };
//     }
// }

// export async function GET_SUBADMIN_USERS(token, subadmin_id) {
//     try {
//         const res = await axios.post(
//             `${Config.base_url}subadmin/get/subadmin/users`,
//             { subadmin_id },
//             { headers: header(token) }
//         );
//         return res.data;
//     } catch (err) {
//         console.error("Error fetching Subadmin users:", err);
//         return { status: false, msg: "Server error", data: [] };
//     }
// }

// export async function GET_SUBADMIN_DASHBOARD_DATA(token, subadmin_id) {
//   try {
//     const res = await axios.post(
//       `${Config.base_url}get/subadmin/users`, 
//       { subadmin_id },
//       { headers: header(token) }
//     );
//     return res.data;
//   } catch (err) {
//     console.error("Error fetching Subadmin dashboard:", err);
//     return { status: false, msg: "Server error", data: [] };
//   }
// }

export const GET_SUBADMIN_DASHBOARD_DATA = async (token, subadmin_id) => {
    try {
        const response = await axios.post(
            `${Config.base_url}get/subadmin/dashboard`,
            { subadmin_id },
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching subadmin dashboard:", error);
        return { status: false, data: [] };
    }
};

export const GET_PANEL_KEY = async (token, panel_key) => {
  try {
    const response = await axios.post(
      `${Config.base_url}get/subadminkey`,
      {
        panel_key, 
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching panel key:", error);
    return { status: false };
  }
};


export const GET_ALL_COMPANY_INFO = async (token) => {
  try {
    const response = await axios.post(
      `${Config.base_url}get/getAllCompanyInfo`,
      {}, // body empty
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching company info:", error);
    return { status: false };
  }
};


